import { Routes } from '@angular/router';
import { ArticleComponent } from './component/article/article.component';
import {BlogComponent} from "./component/blog/blog.component";
import {ArticleResolver} from "./resolver/article.resolver";
import {BlogListResolver} from "./resolver/blog.resolver";

export const routes: Routes = [
  {
    path: '',
    title: 'blog',
    component: BlogComponent,
    resolve: {articles: BlogListResolver}
  },{
    path: 'article',
    children: [{
      path: ':slug',
      title: 'article',
      component: ArticleComponent,
      resolve: { article: ArticleResolver }
    }]
  }
];
